export enum AuthExemptEndpoint {
  Email = 'email',
}
